import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Drawer, Descriptions, Tag, Button, Row, Col, Typography, Spin, Divider, Alert } from 'antd'
import { EditOutlined } from '@ant-design/icons';
import { checkPermission } from '@/utils/permission';
import { renderProfileStatus, repeatPhoneNumber } from '@/utils/helpers';
import { isMobile } from 'react-device-detect';
import CustomerProspectForm from './CustomerProspectForm';
import HandlePhoneNumber from '@/components/HandlePhoneNumber';
import ReactHtmlParser from 'react-html-parser';

const { Paragraph } = Typography;

class CustomerProspectDetail extends Component {
    constructor() {
        super();
        this.state = { isOpenForm: false };
    }

    handleCancel() {
        this.props.onCancel();
    }

    toggleOpenForm(isOpenForm) {
        this.setState({ isOpenForm });
    }

    render() {
        const { isOpenForm } = this.state;
        const { visible, currentItem, loadingDetail } = this.props;

        const statusName = currentItem?.customer_status?.name || '';
        const statusColor = currentItem?.customer_status?.text_color || null;

        const provinceName = currentItem?.province?.name || ''; // new
        // ward name: backend chưa trả -> tạm hiển thị ward_code
        const wardName = currentItem?.ward?.name || currentItem?.ward_name || currentItem?.ward_code || '';

        const groupNames =
            currentItem?.group_names
                ? currentItem.group_names
                : (currentItem?.groups || []).map(g => g?.name).filter(Boolean).join(', ');

        const resultNote = currentItem?.result_note || '';

        const spinning = !!loadingDetail && visible && !currentItem?.id;

        return (
            <>
                <Drawer
                    visible={visible}
                    title="Hồ sơ khách hàng"
                    onClose={() => this.handleCancel()}
                    maskClosable={false}
                    width={isMobile ? '100%' : '65%'}
                    extra={
                        checkPermission('customer_prospect', 'update') ? (
                            <Button type="primary" onClick={() => this.toggleOpenForm(true)} icon={<EditOutlined />}>
                                Sửa
                            </Button>
                        ) : null
                    }
                >
                    {visible ? (
                        <div className='wrap-customer-detail'>
                            <Spin tip="Loading..." spinning={spinning}>
                                <Row gutter={16}>
                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Tên khách hàng">
                                                {currentItem?.full_name || null}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>

                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Mã số thẻ cũ">
                                                {currentItem?.card_number ? (
                                                    <Paragraph
                                                        style={{ margin: 0 }}
                                                        copyable={{ text: currentItem.card_number, tooltips: false }}
                                                    >
                                                        <Tag color='#858383'>{currentItem.card_number}</Tag>
                                                    </Paragraph>
                                                ) : null}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>

                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Mã số thẻ mới">
                                                {currentItem?.card_number_new ? (
                                                    <Paragraph
                                                        style={{ margin: 0 }}
                                                        copyable={{ text: currentItem.card_number_new, tooltips: false }}
                                                    >
                                                        <Tag color='#1890ff'>{currentItem.card_number_new}</Tag>
                                                    </Paragraph>
                                                ) : null}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>

                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Số điện thoại">
                                                {currentItem ? (
                                                    <HandlePhoneNumber
                                                        permission={checkPermission('customer_prospect', 'phonenumber')}
                                                        inputPinCode={checkPermission('customer_prospect', 'input_pin_code')}
                                                        customer_id={currentItem?.id}
                                                        hiddenPhoneNumber={repeatPhoneNumber(currentItem?.phone)}
                                                        fullPhoneNumber={currentItem?.phone}
                                                    />
                                                ) : null}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>

                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Giới tính">
                                                <span style={{ textTransform: 'capitalize' }}>
                                                    {currentItem?.gender || ''}
                                                </span>
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>

                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Năm sinh">
                                                {currentItem?.birthday || null}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>

                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Trạng thái">
                                                {statusName ? (
                                                    statusColor ? (
                                                        <Tag color={statusColor}>{statusName}</Tag>
                                                    ) : (
                                                        <Tag>{statusName}</Tag>
                                                    )
                                                ) : null}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className="no-margin" />
                                    </Col>

                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Nhóm">
                                                {groupNames || null}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>

                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Tỉnh/Thành phố">
                                                {provinceName || null}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>

                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Phường/Xã">
                                                {wardName || null}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>

                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Tổ">
                                                {currentItem?.residential_group || null}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>

                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Địa chỉ">
                                                {currentItem?.address || null}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>

                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Ghi chú">
                                                {ReactHtmlParser(currentItem?.note || '')}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>

                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Danh sách">
                                                {currentItem?.list_name || null}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>

                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Hồ sơ">
                                                {renderProfileStatus(currentItem?.has_profile)}
                                            </Descriptions.Item>
                                        </Descriptions>
                                    </Col>

                                    <Col xs={24} md={24} className='mt-2 mb-2'>
                                        <Alert
                                            message={<span style={{ fontWeight: 600 }}>Kết quả tư vấn</span>}
                                            description={ReactHtmlParser(resultNote)}
                                            type="info"
                                            className='fix-alert-element'
                                        />
                                    </Col>
                                </Row>
                            </Spin>
                        </div>
                    ) : null}
                </Drawer>

                <CustomerProspectForm
                    visible={isOpenForm}
                    currentItem={currentItem}
                    reloadData={() => this.props.reloadData()}
                    onCancel={() => this.toggleOpenForm(false)}
                />
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        authUser: state.auth.authUser
    }
}

function mapDispatchToProps(dispatch) {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'CustomerProspectDetail' })(CustomerProspectDetail));
